import { CloseIcon } from '@airship-platform/jam-web/icons';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { AppointmentProposalOption } from '../../../data-access/appointmentProposalOptions';

interface SoldOptionAlertProps {
  option: AppointmentProposalOption | undefined;
}

const SoldOptionAlert: React.FC<SoldOptionAlertProps> = ({ option }) => {
  const [open, setOpen] = useState(true);

  const isLocked = option?.isReadOnly;

  if (
    !open ||
    !isLocked ||
    (option?.status !== 'ACCEPTED' && option?.status !== 'SOLD')
  ) {
    return null;
  }

  const url = option.externalIds
    .flatMap((id) =>
      typeof id.id === 'string' && id.name === 'estimateUrl' ? [id.id] : []
    )
    .at(0);

  const message =
    option.status === 'ACCEPTED' ? (
      <>
        {option.name} has been accepted by the customer and can&apos;t be
        edited.
      </>
    ) : (
      <>
        {option.name} has been marked as Sold in ServiceTitan and can&apos;t be
        edited. To make changes, please{' '}
        <Typography variant="body2" key={url} component={Link} href={url}>
          reopen the job
        </Typography>
        .
      </>
    );

  return (
    <Alert
      severity="warning"
      action={
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={() => setOpen(false)}
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
      }
      sx={{ mb: 2 }}
    >
      {message}
    </Alert>
  );
};

export default SoldOptionAlert;
